var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "200px",
  height: "200px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  className: "lds-rolling",
  style: {
    background: "none"
  }
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  fill: "none",
  ngattrstroke: "{{config.color}}",
  ngattrstrokewidth: "{{config.width}}",
  ngattrr: "{{config.radius}}",
  ngattrstrokedasharray: "{{config.dasharray}}",
  stroke: "#084782",
  strokeWidth: 2,
  r: 24,
  strokeDasharray: "70.68583470577033 25.561944901923447",
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  calcMode: "linear",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: "1.5s",
  begin: "0s",
  repeatCount: "indefinite"
}))));
export { SvgLoading as ReactComponent };